import { render, staticRenderFns } from "./ByStorage.vue?vue&type=template&id=3547ee4c&scoped=true"
import script from "./ByStorage.vue?vue&type=script&lang=js"
export * from "./ByStorage.vue?vue&type=script&lang=js"
import style0 from "./ByStorage.vue?vue&type=style&index=0&id=3547ee4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547ee4c",
  null
  
)

export default component.exports